export default __webpack_public_path__ + "static/media/shopifyExtension3.05438846.svg";